<template>
    <b-modal ref="dropZoneImagePreview" v-model="show" size="xl" class="dropzone-image-preview"
             :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid pl-0 pr-0">
            <div class="row">
                <div class="col-12 text-center">
                    <img :src="data.url" class="img-preview" style="max-width: 100%"/>
                </div>
            </div>
        </div>

        <div slot="modal-footer">
            <!--<button class="all-btn float-right mr-2" @click="close">-->
                <!--OK-->
            <!--</button>-->
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal';
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal';
    export default {
        name: "RealEstateDropZonePreview",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                data: {}
            }
        },
        methods: {
            close() {
                this.$refs.dropZoneImagePreview.hide();
            }
        },
        created() {
            this.$eventBus.$on('showDropZoneImagePreview', (data) => {
                this.data = data;
                this.show = true;
            });
        }
    }
</script>

<style>
    .dropzone-image-preview .modal-dialog {
        max-width: 100% !important;
        width: 1000px !important;
    }
    .dropzone-image-preview .modal-content {
        width: 100% !important;
    }
    .dropzone-image-preview .img-preview {
        width: 100% !important;
    }
    .dropzone-image-preview > div {
        z-index: 100000 !important;
    }
</style>